import { deleteApi, get, post } from "../GenericServices";

const ProductCategory = {
  productCategories: (queryString) => {
    return get(`product-category?${queryString}`);
  },
  saveProductCategory: (data) => {
    return post("product-category", data);
  },
  productDetail: (id) => {
    return get(`product-category/${id}`);
  },
  deleteProductCategory: (id) => {
    return deleteApi(`product-category/${id}`);
  },
};

export default ProductCategory;
